/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable sort-imports */
import axios from 'axios';
import './printFlightTicket.scss';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import React, { Component, createRef } from 'react';
import '../flightInformation/flightInformation.scss';
import { bookingApi } from '../../../../services/apis';
import MobileTicket from '../mobileTicket/mobileTicket';
import { FormattedMessage, injectIntl } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts';
import { fullMonths } from '../../../../utils/consts/months';
import { Conditional } from '../../../../utils/consts/index';
import { isTripord } from '../../../../utils/consts/general';
import * as languageActions from '../../../../actions/language';
import { colors } from '../../../../utils/consts/color-variable';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import { checkMobileDevice } from '../../../../utils/utility/index';
import { returnFlightDate } from '../../../../utils/utility/booking';
import {
  QRcode,
  NotAvailableFlight,
  Spinner,
  TicketFlightDetails,
  Toast,
} from '../../..';
import {
  CheckIcon,
  StopwatchIcon,
  OnlinePaymentIcon,
  UsdCircleIcon,
  DownloadIcon,
  EditIcon,
  EmailIcon,
} from '~svg';

let parsedQueryStr = '';
class PrintFlightTicket extends Component {
  constructor(props) {
    super(props);
    this.printer = createRef(null);
    parsedQueryStr =
      props?.printData ||
      Object.fromEntries(new URLSearchParams(props?.location?.search));
    this.state = {
      showLoading: true,
      currentIndex: 0,
      currentFlight: {},
      noResult: false,
      node: null,
      toast: false,
      toastState: 'success',
      alertMessage: 'ok',
    };
  }
  //use for create pdf using package
  componentDidMount = () => {
    !checkMobileDevice() ? this.handleScroll() : null;
    this.fetchFlightInfo();
  };
  componentWillUnmount() {
    this.removeScroll();
  }

  handleScroll = () => {
    document.addEventListener('load', () => {
      window.scrollTo({
        top: 55,
        behavior: 'smooth',
      });
    });
    window.scrollTo({
      top: 55,
      behavior: 'smooth',
    });
  };
  removeScroll = () => {
    window.removeEventListener('load', this.handleScroll());
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  async fetchFlightInfo() {
    try {
      const { payload } = await bookingApi.getBookingById(parsedQueryStr.id);

      if (payload.data) {
        this.setState({
          currentFlight: payload.data,
          showLoading: false,
        });
      } else {
        this.setState({
          currentFlight: {},
          noResult: true,
          showLoading: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  changeTicketLanguage = (language, captureDiv) => {
    this.props.changeLanguage(language);
  };
  emailTicket = async () => {
    const { name } = this.props.language;
    const { currentFlight } = this.state;

    try {
      const { payload } = await bookingApi.emailTicket({
        data: {
          id: currentFlight._id,
          language: name,
          email: currentFlight.issuerContactInfo.email,
        },
      });

      this.setState({
        toast: true,
        alertMessage: payload?.data,
        toastState: 'success',
      });
    } catch (error) {
      this.setState({
        toast: true,
        alertMessage: error,
        toastState: 'danger',
      });
    }
  };
  viewFile = async (url, headers) => {
    try {
      const response = await axios.get(url, {
        headers: headers,
        responseType: 'arraybuffer', // Set responseType to 'blob'
      });

      const blob = new Blob([response.data], {
        type: 'application/pdf', // Set the correct MIME type for your file
      });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank').focus();
    } catch (err) {
      console.error(err);
    }
  };

  downLoadPDF = () => {
    const { name } = this.props.language;
    const id = parsedQueryStr?.id;

    this.viewFile(
      `https://api.${
        isTripord ? 'tripord.com' : 'tripsi.ir'
      }/invoice/ticket/download/${name}/${id}`,
      {
        headers: { 'Content-type': 'applcation/pdf', type: 'applcation/pdf' },
      },
    );
  };

  renderMiladiDate = (date, index) => {
    if (date !== undefined && date !== null && date !== '') {
      date = date.split('T')[0].split('-');
      return `${date[2]} ${fullMonths['ltr']['fa'][date[1] - 1]} ${date[0]}`;
    }
  };
  // show ticket data
  renderTicket() {
    let { name, direction } = this.props.language;
    let { currentFlight, toast, toastState, alertMessage, node } = this.state;

    return (
      <>
        <Toast
          isOpen={toast}
          onClose={() => this.setState({ toast: false })}
          state={toastState}
          position="bottom"
          message={alertMessage}
          direction={direction}
        />
        <div>
          <div
            className="d-flex d-sm-none col-12 p-0 m-0 justify-content-center"
            style={{
              background: '#f6f5fb',
              height: '100vh',
              overflowX: 'hidden',
            }}
          >
            <MobileTicket
              refrence={node}
              currentFlight={currentFlight}
              parsedQueryStr={parsedQueryStr}
              name={name}
              direction={direction}
              renderTicketContainer={() =>
                this.renderTicketContainer(currentFlight, name, direction)
              }
            />
          </div>
          {/* ---------------------------------------------------------------------- */}
          <div
            className={`d-none d-sm-flex w-100 p-2 ${
              direction === 'rtl' ? 'align-items-end' : 'align-items-start'
            } justify-content-center flex-column`}
          >
            <div
              style={{ direction }}
              className={`d-flex w-100 justify-content-center align-content-center py-2`}
            >
              <div className="d-flex justify-content-around align-items-start w-100">
                <div className="d-flex align-items-center justify-content-between pt-1">
                  <img
                    className="rounded-circle cursor-pointer mx-1"
                    alt="country-flag"
                    src={`${fileHandlerUrl}/icons/flags/iran.png`}
                    width="18"
                    height="18"
                  />
                  <span
                    className="text-secondary font-smaller px-1 text-underline cursor-pointer"
                    onClick={() => {
                      this.changeTicketLanguage('fa');
                    }}
                  >
                    <FormattedMessage id="footer.persian" />
                  </span>
                  <span
                    className="text-secondary font-smaller px-1 text-underline cursor-pointer"
                    onClick={() => {
                      this.changeTicketLanguage('en');
                    }}
                  >
                    {' '}
                    <img
                      className="rounded-circle cursor-pointer mx-1"
                      alt="country-flag"
                      src={`${fileHandlerUrl}/icons/flags/english.png`}
                      width="18"
                      height="18"
                    />{' '}
                    <FormattedMessage id="footer.english" />{' '}
                  </span>
                </div>

                <div
                  style={{ cursor: 'pointer' }}
                  className={`font-weight-bold `}
                  onClick={() => this.downLoadPDF()}
                >
                  <div className="d-flex flex-column ">
                    <div className="d-flex align-items-center">
                      <DownloadIcon size={18} color={colors.secondary} />
                      <span className="text-dark font-small px-1">
                        <FormattedMessage
                          id="booking.printticket"
                          defaultMessage="booking.printticket"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                {/* )}
                  /> */}

                <div
                  className={`font-weight-bold cursor-pointer`}
                  onClick={() => this.emailTicket()}
                >
                  <EmailIcon size={18} color={colors.secondary} />

                  <span className="text-dark font-small px-1">
                    <FormattedMessage id="booking.emailticket" />
                  </span>
                </div>
                <div className={`font-weight-bold cursor-pointer`}>
                  <EditIcon size={18} color={colors.secondary} />
                  <span className="text-dark font-small px-1">
                    <FormattedMessage id="booking.changeticketprice" />
                  </span>
                </div>
              </div>
            </div>
            {this.renderTicketContainer(currentFlight, name, direction)}
          </div>
        </div>
        {/*  )} */}
      </>
    );
  }
  renderPassengerSection = (passenger) => {
    let { name, direction } = this.props.language;

    let { currentFlight } = this.state,
      AgencyLogo = currentFlight?.onBehalfProfile?.basicInfo?.logo || '';

    return (
      <div className="col-12  border-3 border-primary-light border-bottom p-1 ">
        <h4 className="py-2 d-flex justify-content-center text-primary">
          <span>{passenger.lastName}</span>
          <span className="px-1">/</span>
          <span>{passenger.firstName}</span>
        </h4>
        <div className="d-flex">
          <div className="d-flex col-5 px-0">
            <div className="d-flex flex-column w-100 align-items-center justify-content-center font-weight-bold font-small">
              <div className="d-flex  align-items-center w-100 px-2  ">
                <div className="d-flex mx-1  justify-content-start align-items-center text-center text-gray  ">
                  <FormattedMessage id="booking.issueDate" />
                </div>
                :
                <div className="font-smaller mx-1 d-flex justify-content-end align-items-center  text-center text-primary text-captalize">
                  <span className="d-flex text-primary  align-items-center justify-content-center">
                    {direction === 'rtl' &&
                      returnFlightDate(currentFlight.bookDate, 'fa', false)}
                  </span>
                  <span className="px-1  text-primary">،</span>
                  {direction === 'rtl' && (
                    <span className="d-flex text-primary  align-items-center justify-content-center">
                      {this.renderMiladiDate(currentFlight.bookDate)}
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex  align-items-center w-100 px-2  ">
                <div
                  className="
                d-flex justify-content-start mx-1  align-items-center text-center text-gray "
                >
                  <FormattedMessage id="booking.exporter" />
                </div>
                :
                <div className="font-smaller mx-1 d-flex justify-content-end align-items-center text-center text-primary  text-captalize">
                  {currentFlight?.onBehalfProfile?.businessType?.name?.[name] ||
                    '--'}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex col-2">
            <div className="d-flex justify-content-center align-items-center w-100">
              <QRcode
                imgBg={true}
                url={`print-flight-ticket?print=1&id=${parsedQueryStr.id}`}
                value={`https://tripsi.ir/#/booking/print-flight-ticket?print=1&id=${parsedQueryStr.id}`}
                imgSrc={AgencyLogo}
                renderAs="canvas"
                size={85}
                errorCorrectionLevel="H"
                imgWidth={30}
                imgHeight={30}
              />
            </div>
          </div>
          <div className="d-flex col-5 px-0">
            <div className="d-flex flex-column w-100 align-items-center justify-content-center font-weight-bold font-small">
              <div className="d-flex justify-content-end align-items-center w-100 ">
                <span className="d-flex align-items-center  text-gray col-3 px-0  ">
                  <FormattedMessage id="booking.phone" /> :
                </span>

                <span
                  className={`d-flex align-items-center  ltr-direction  justify-content-${
                    direction === 'rtl' ? 'start' : 'end'
                  } text-primary px-0  col-5`}
                >
                  {currentFlight.issuerContactInfo.mobile}
                </span>
              </div>
              <div className="d-flex justify-content-end align-items-center w-100 ">
                <span className="d-flex align-items-center  text-center text-gray col-3 px-0 ">
                  <FormattedMessage id="booking.email" /> :
                </span>

                <span
                  className={`d-flex  align-items-center ltr-direction  justify-content-${
                    direction === 'rtl' ? 'start' : 'end'
                  } text-break  text-primary px-0  col-5 `}
                >
                  {currentFlight.issuerContactInfo.email}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderFlightSection = (currentFlight, index) => {
    let { name, direction } = this.props.language;
    let { currentIndex } = this.state;
    return (
      <div className=" w-100 align-items-center justify-content-center pt-2    ">
        <div
          className={`d-flex flex-column w-100  ${
            currentFlight.flights.itineraries.length === 1 &&
            'border-bottom border-3 border-primary'
          } justify-content-center align-items-center `}
        >
          {currentFlight.flights.itineraries.map((item, findex) => {
            let currentTicket =
              (currentFlight.tickets &&
                currentFlight.tickets.length &&
                currentFlight.tickets.filter(
                  (t) => t.passengerIndex === index && t.flightIndex === findex,
                )[0]) ||
              null;
            let allAirlines = [
              ...new Set(item.flights.map((t) => [t.operatingAirline])),
            ].reduce((a, b) => {
              return a.concat(b);
            });
            let operatingAirline = [
              ...new Map(allAirlines.map((item) => [item.code, item])).values(),
            ];
            let airlineName =
              operatingAirline.length === 1
                ? operatingAirline[0].name[name]
                : this.props.intl.formatMessage({
                    id: 'booking.multiairline',
                  });
            return (
              <div
                key={`currentFlightCard-${findex}`}
                className={`d-flex px-0 flex-column  justify-content-center  align-items-center  text-center text-primary `}
                style={{
                  width: '100%',
                  borderRadius: 5,
                  marginLeft: findex === 0 && direction === 'rtl' ? 6 : 0,
                  marginRight: findex === 0 && direction === 'ltr' ? 6 : 0,
                }}
              >
                <div className={`w-100 py-3`}>
                  <div
                    className={` w-100 font-smaller ${
                      item.index === 0 ? ' d-flex ' : 'd-none'
                    }`}
                  >
                    <span className="px-1">
                      <FormattedMessage id="booking.departureflight" />
                    </span>
                    <span className="d-flex text-secondary  align-items-center justify-content-center">
                      {direction === 'rtl' &&
                        returnFlightDate(
                          item.flights[0].departureDateTime,
                          'fa',
                          false,
                        )}
                    </span>
                    <span className="px-1  text-secondary">،</span>
                    {direction === 'rtl' && (
                      <span className="d-flex text-secondary  align-items-center justify-content-center">
                        {this.renderMiladiDate(
                          item.flights[0].departureDateTime,
                        )}
                      </span>
                    )}
                  </div>
                  <div
                    className={` w-100  font-smaller ${
                      item.index === 1 ? ' d-flex ' : 'd-none'
                    }`}
                  >
                    <span className="px-5">
                      <FormattedMessage id="booking.returnflight" />
                    </span>
                    <span className="d-flex text-secondary ">
                      {direction === 'rtl' &&
                        returnFlightDate(
                          item.flights[0].departureDateTime,
                          'fa',
                          false,
                        )}
                    </span>
                    <span className="px-1  text-secondary">،</span>
                    {direction === 'rtl' && (
                      <span className="d-flex text-secondary ">
                        {this.renderMiladiDate(
                          item.flights[0].departureDateTime,
                        )}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className={`w-100 d-flex  justify-content-center align-items-start  mt-2 ${
                    currentFlight.flights.itineraries.length > 1
                      ? 'border-bottom border-primary border-3'
                      : ''
                  } `}
                >
                  <TicketFlightDetails
                    flights={currentFlight.flights}
                    tickets={currentFlight.tickets}
                    index={currentIndex}
                    detail={item.flights}
                    flightType={currentFlight.flights.flightType}
                    showModal={false}
                    showPrice={false}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  renderTicketContainer = (currentFlight, name, direction) => {
    let { currentIndex } = this.state;
    let passenger =
      Object.entries(currentFlight).length > 0 && currentFlight.flights
        ? currentFlight.passengers[currentIndex]
        : {};

    return (
      <div
        className={`d-flex w-100 flex-column${
          direction === 'rtl' ? 'align-items-end' : 'align-items-start'
        }`}
      >
        <div
          style={{
            direction:
              parsedQueryStr.print && parsedQueryStr.print === 1
                ? 'ltr'
                : direction,
          }}
          className={` m-0 col-12 ${
            checkMobileDevice() ? 'd-none' : 'd-flex'
          } justify-content-center align-items-center p-0`}
          id="capture"
        >
          <div direction={direction}>
            <div className="width h-100 ">
              {currentFlight &&
              Object.entries(currentFlight).length > 0 &&
              currentFlight.flights ? (
                <div
                  style={{
                    margin: 1,
                    direction,
                  }}
                  key={`ticket-${currentIndex}`}
                  className="d-flex flex-column w-100 h-100 pt-1 mx-0 subpage  position-relative"
                >
                  <div className="d-flex w-100 px-2 h-100 align-items-start">
                    <div className="d-flex flex-column  w-100 justify-content-center align-items-start">
                      {this.renderPassengerSection(passenger, currentIndex)}
                      {this.renderFlightSection(currentFlight, currentIndex)}

                      <div className="d-flex flex-column align-items-start font-smaller text-gray py-5 px-3">
                        <div className="d-flex text-primary">
                          <span>
                            <CheckIcon size={22} color="#aaacaf" />
                          </span>
                          <h5 className=" px-2 no-space">
                            <FormattedMessage id="booking.importantTips" />
                          </h5>
                        </div>

                        <span
                          className="d-flex align-items-center"
                          style={{ height: '3rem' }}
                        >
                          <StopwatchIcon size={26} color="#aaacaf" />
                          <span className="px-3">
                            <FormattedMessage id="booking.passengerArrivringTip" />
                          </span>
                        </span>
                        <div
                          className="d-flex align-items-center"
                          style={{ height: '3rem' }}
                        >
                          <UsdCircleIcon size={26} color="#aaacaf" />
                          <span className="px-3">
                            <FormattedMessage id="booking.allpriceisrial" />
                          </span>
                        </div>
                        <div
                          className="d-flex align-items-center"
                          style={{ height: '3rem' }}
                        >
                          <OnlinePaymentIcon size={26} color="#aaacaf" />
                          <span className="px-3">
                            <FormattedMessage id="booking.payTextTip" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Conditional
                    checkRender={
                      !(currentFlight.tickets[0]?.showTicketType?.code == 2)
                    }
                  >
                    <div className="d-flex h-100 w-100 align-items-end">
                      <div className="w-100  d-flex  mb-3 justify-content-center align-items-center border-primary-light  border-top border-3 border-gray mt-4 ">
                        <div className="w-75 d-flex  justify-content-center align-items-center flex-column ">
                          <div className="d-flex w-100 justify-content-between font-medium  pt-4 text-third">
                            <FormattedMessage id="booking.fareprice" />
                            <FormattedMessage id="booking.tax" />
                            <FormattedMessage id="booking.totalprice" />
                          </div>
                          <div className="d-flex w-100 justify-content-between font-medium mt-2 text-third">
                            <div className="text-third font-medium font-weight-normal">
                              {numberWithCommas(
                                +currentFlight.tickets[0]?.showTicketType
                                  ?.code == 3
                                  ? +passenger.price.baseFare -
                                      +(
                                        currentFlight.tickets[0].agencyMarkup /
                                        10
                                      )
                                  : passenger.price.baseFare,
                              )}
                            </div>
                            <div className="text-third font-medium font-weight-normal">
                              {numberWithCommas(passenger.price.tax)}
                            </div>
                            <div className="text-primary font-medium font-weight-bold">
                              {numberWithCommas(
                                +currentFlight.tickets[0]?.showTicketType
                                  .code == 3
                                  ? +passenger.price.totalPrice -
                                      +(
                                        currentFlight.tickets[0].agencyMarkup /
                                        10
                                      )
                                  : passenger.price.totalPrice,
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Conditional>
                </div>
              ) : (
                <></>
              )}
            </div>{' '}
            <div className="d-flex col-12 justify-content-center py-5">
              {currentFlight.passengers.length > 1
                ? currentFlight.passengers.map((_, index) => (
                    <div
                      onClick={() => this.setState({ currentIndex: index })}
                      style={{ width: 25, height: 25 }}
                      className={`d-flex ${
                        currentIndex !== index
                          ? 'border-third bg-white text-primary'
                          : 'border-third bg-primary text-white'
                      } rounded-circle mx-2 cursor-pointer  border border-2  pt-1  align-items-center justify-content-center`}
                      key={`page${index}`}
                    >
                      {index + 1}
                    </div>
                  ))
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { currentFlight, showLoading, noResult } = this.state;

    return (
      <>
        <Conditional checkRender={showLoading}>
          <Spinner />
        </Conditional>

        {currentFlight && Object.entries(currentFlight).length > 0 ? (
          this.renderTicket()
        ) : noResult ? (
          <NotAvailableFlight
            hasFilter="false"
            message="profile.notfound"
            isMobileDevice={checkMobileDevice()}
          />
        ) : null}
      </>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeLanguage: (lang) => dispatch(languageActions.changeLanguage(lang)),
  };
}
export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(PrintFlightTicket)),
);
